/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TenantPickerRouteImport } from './routes/tenant-picker'
import { Route as SuppliersRouteImport } from './routes/suppliers'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RemindersRouteImport } from './routes/reminders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as ExportRouteImport } from './routes/export'
import { Route as ExpensesRouteImport } from './routes/expenses'
import { Route as EstimatesRouteImport } from './routes/estimates'
import { Route as DepreciationsRouteImport } from './routes/depreciations'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as ContractsRouteImport } from './routes/contracts'
import { Route as CashflowRouteImport } from './routes/cashflow'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuppliersIdRouteImport } from './routes/suppliers_.$id'
import { Route as SettingsCategoriesRouteImport } from './routes/settings_.categories'
import { Route as InvoicesNewRouteImport } from './routes/invoices_.new'
import { Route as InvoicesIdRouteImport } from './routes/invoices_.$id'
import { Route as ExpensesUploadRouteImport } from './routes/expenses_.upload'
import { Route as ExpensesNewRouteImport } from './routes/expenses_.new'
import { Route as ExpensesExportRouteImport } from './routes/expenses_.export'
import { Route as ExpensesDurcharbeiteRouteImport } from './routes/expenses_.durcharbeite'
import { Route as ExpensesIdRouteImport } from './routes/expenses_.$id'
import { Route as EstimatesNewRouteImport } from './routes/estimates_.new'
import { Route as EstimatesIdRouteImport } from './routes/estimates_.$id'
import { Route as CustomersNewRouteImport } from './routes/customers_.new'
import { Route as CustomersIdRouteImport } from './routes/customers_.$id'
import { Route as ContractsNewRouteImport } from './routes/contracts_.new'
import { Route as ContractsIdRouteImport } from './routes/contracts_.$id'
import { Route as InvoicesIdEditRouteImport } from './routes/invoices_.$id_.edit'
import { Route as ExpensesIdOcrDebugRouteImport } from './routes/expenses_.$id_.ocr-debug'
import { Route as ExpensesIdEditRouteImport } from './routes/expenses_.$id_.edit'
import { Route as EstimatesIdEditRouteImport } from './routes/estimates_.$id_.edit'
import { Route as ContractsIdEditRouteImport } from './routes/contracts_.$id_.edit'

const TenantPickerRoute = TenantPickerRouteImport.update({
  id: '/tenant-picker',
  path: '/tenant-picker',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersRoute = RemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesRoute = ExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesRoute = EstimatesRouteImport.update({
  id: '/estimates',
  path: '/estimates',
  getParentRoute: () => rootRouteImport,
} as any)
const DepreciationsRoute = DepreciationsRouteImport.update({
  id: '/depreciations',
  path: '/depreciations',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsRoute = ContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => rootRouteImport,
} as any)
const CashflowRoute = CashflowRouteImport.update({
  id: '/cashflow',
  path: '/cashflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIdRoute = SuppliersIdRouteImport.update({
  id: '/suppliers_/$id',
  path: '/suppliers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCategoriesRoute = SettingsCategoriesRouteImport.update({
  id: '/settings_/categories',
  path: '/settings/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/invoices_/new',
  path: '/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesUploadRoute = ExpensesUploadRouteImport.update({
  id: '/expenses_/upload',
  path: '/expenses/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesNewRoute = ExpensesNewRouteImport.update({
  id: '/expenses_/new',
  path: '/expenses/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesExportRoute = ExpensesExportRouteImport.update({
  id: '/expenses_/export',
  path: '/expenses/export',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesDurcharbeiteRoute = ExpensesDurcharbeiteRouteImport.update({
  id: '/expenses_/durcharbeite',
  path: '/expenses/durcharbeite',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIdRoute = ExpensesIdRouteImport.update({
  id: '/expenses_/$id',
  path: '/expenses/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesNewRoute = EstimatesNewRouteImport.update({
  id: '/estimates_/new',
  path: '/estimates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesIdRoute = EstimatesIdRouteImport.update({
  id: '/estimates_/$id',
  path: '/estimates/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/customers_/new',
  path: '/customers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers_/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsNewRoute = ContractsNewRouteImport.update({
  id: '/contracts_/new',
  path: '/contracts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsIdRoute = ContractsIdRouteImport.update({
  id: '/contracts_/$id',
  path: '/contracts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdEditRoute = InvoicesIdEditRouteImport.update({
  id: '/invoices_/$id_/edit',
  path: '/invoices/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIdOcrDebugRoute = ExpensesIdOcrDebugRouteImport.update({
  id: '/expenses_/$id_/ocr-debug',
  path: '/expenses/$id/ocr-debug',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIdEditRoute = ExpensesIdEditRouteImport.update({
  id: '/expenses_/$id_/edit',
  path: '/expenses/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimatesIdEditRoute = EstimatesIdEditRouteImport.update({
  id: '/estimates_/$id_/edit',
  path: '/estimates/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsIdEditRoute = ContractsIdEditRouteImport.update({
  id: '/contracts_/$id_/edit',
  path: '/contracts/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/audit-log': typeof AuditLogRoute
  '/cashflow': typeof CashflowRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/depreciations': typeof DepreciationsRoute
  '/estimates': typeof EstimatesRoute
  '/expenses': typeof ExpensesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/suppliers': typeof SuppliersRoute
  '/tenant-picker': typeof TenantPickerRoute
  '/contracts/$id': typeof ContractsIdRoute
  '/contracts/new': typeof ContractsNewRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/estimates/$id': typeof EstimatesIdRoute
  '/estimates/new': typeof EstimatesNewRoute
  '/expenses/$id': typeof ExpensesIdRoute
  '/expenses/durcharbeite': typeof ExpensesDurcharbeiteRoute
  '/expenses/export': typeof ExpensesExportRoute
  '/expenses/new': typeof ExpensesNewRoute
  '/expenses/upload': typeof ExpensesUploadRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/settings/categories': typeof SettingsCategoriesRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/contracts/$id/edit': typeof ContractsIdEditRoute
  '/estimates/$id/edit': typeof EstimatesIdEditRoute
  '/expenses/$id/edit': typeof ExpensesIdEditRoute
  '/expenses/$id/ocr-debug': typeof ExpensesIdOcrDebugRoute
  '/invoices/$id/edit': typeof InvoicesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/audit-log': typeof AuditLogRoute
  '/cashflow': typeof CashflowRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/depreciations': typeof DepreciationsRoute
  '/estimates': typeof EstimatesRoute
  '/expenses': typeof ExpensesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/suppliers': typeof SuppliersRoute
  '/tenant-picker': typeof TenantPickerRoute
  '/contracts/$id': typeof ContractsIdRoute
  '/contracts/new': typeof ContractsNewRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/estimates/$id': typeof EstimatesIdRoute
  '/estimates/new': typeof EstimatesNewRoute
  '/expenses/$id': typeof ExpensesIdRoute
  '/expenses/durcharbeite': typeof ExpensesDurcharbeiteRoute
  '/expenses/export': typeof ExpensesExportRoute
  '/expenses/new': typeof ExpensesNewRoute
  '/expenses/upload': typeof ExpensesUploadRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/settings/categories': typeof SettingsCategoriesRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/contracts/$id/edit': typeof ContractsIdEditRoute
  '/estimates/$id/edit': typeof EstimatesIdEditRoute
  '/expenses/$id/edit': typeof ExpensesIdEditRoute
  '/expenses/$id/ocr-debug': typeof ExpensesIdOcrDebugRoute
  '/invoices/$id/edit': typeof InvoicesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/audit-log': typeof AuditLogRoute
  '/cashflow': typeof CashflowRoute
  '/contracts': typeof ContractsRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/depreciations': typeof DepreciationsRoute
  '/estimates': typeof EstimatesRoute
  '/expenses': typeof ExpensesRoute
  '/export': typeof ExportRoute
  '/invoices': typeof InvoicesRoute
  '/login': typeof LoginRoute
  '/reminders': typeof RemindersRoute
  '/settings': typeof SettingsRoute
  '/suppliers': typeof SuppliersRoute
  '/tenant-picker': typeof TenantPickerRoute
  '/contracts_/$id': typeof ContractsIdRoute
  '/contracts_/new': typeof ContractsNewRoute
  '/customers_/$id': typeof CustomersIdRoute
  '/customers_/new': typeof CustomersNewRoute
  '/estimates_/$id': typeof EstimatesIdRoute
  '/estimates_/new': typeof EstimatesNewRoute
  '/expenses_/$id': typeof ExpensesIdRoute
  '/expenses_/durcharbeite': typeof ExpensesDurcharbeiteRoute
  '/expenses_/export': typeof ExpensesExportRoute
  '/expenses_/new': typeof ExpensesNewRoute
  '/expenses_/upload': typeof ExpensesUploadRoute
  '/invoices_/$id': typeof InvoicesIdRoute
  '/invoices_/new': typeof InvoicesNewRoute
  '/settings_/categories': typeof SettingsCategoriesRoute
  '/suppliers_/$id': typeof SuppliersIdRoute
  '/contracts_/$id_/edit': typeof ContractsIdEditRoute
  '/estimates_/$id_/edit': typeof EstimatesIdEditRoute
  '/expenses_/$id_/edit': typeof ExpensesIdEditRoute
  '/expenses_/$id_/ocr-debug': typeof ExpensesIdOcrDebugRoute
  '/invoices_/$id_/edit': typeof InvoicesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/audit-log'
    | '/cashflow'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/depreciations'
    | '/estimates'
    | '/expenses'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/suppliers'
    | '/tenant-picker'
    | '/contracts/$id'
    | '/contracts/new'
    | '/customers/$id'
    | '/customers/new'
    | '/estimates/$id'
    | '/estimates/new'
    | '/expenses/$id'
    | '/expenses/durcharbeite'
    | '/expenses/export'
    | '/expenses/new'
    | '/expenses/upload'
    | '/invoices/$id'
    | '/invoices/new'
    | '/settings/categories'
    | '/suppliers/$id'
    | '/contracts/$id/edit'
    | '/estimates/$id/edit'
    | '/expenses/$id/edit'
    | '/expenses/$id/ocr-debug'
    | '/invoices/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/audit-log'
    | '/cashflow'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/depreciations'
    | '/estimates'
    | '/expenses'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/suppliers'
    | '/tenant-picker'
    | '/contracts/$id'
    | '/contracts/new'
    | '/customers/$id'
    | '/customers/new'
    | '/estimates/$id'
    | '/estimates/new'
    | '/expenses/$id'
    | '/expenses/durcharbeite'
    | '/expenses/export'
    | '/expenses/new'
    | '/expenses/upload'
    | '/invoices/$id'
    | '/invoices/new'
    | '/settings/categories'
    | '/suppliers/$id'
    | '/contracts/$id/edit'
    | '/estimates/$id/edit'
    | '/expenses/$id/edit'
    | '/expenses/$id/ocr-debug'
    | '/invoices/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/audit-log'
    | '/cashflow'
    | '/contracts'
    | '/customers'
    | '/dashboard'
    | '/depreciations'
    | '/estimates'
    | '/expenses'
    | '/export'
    | '/invoices'
    | '/login'
    | '/reminders'
    | '/settings'
    | '/suppliers'
    | '/tenant-picker'
    | '/contracts_/$id'
    | '/contracts_/new'
    | '/customers_/$id'
    | '/customers_/new'
    | '/estimates_/$id'
    | '/estimates_/new'
    | '/expenses_/$id'
    | '/expenses_/durcharbeite'
    | '/expenses_/export'
    | '/expenses_/new'
    | '/expenses_/upload'
    | '/invoices_/$id'
    | '/invoices_/new'
    | '/settings_/categories'
    | '/suppliers_/$id'
    | '/contracts_/$id_/edit'
    | '/estimates_/$id_/edit'
    | '/expenses_/$id_/edit'
    | '/expenses_/$id_/ocr-debug'
    | '/invoices_/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AuditLogRoute: typeof AuditLogRoute
  CashflowRoute: typeof CashflowRoute
  ContractsRoute: typeof ContractsRoute
  CustomersRoute: typeof CustomersRoute
  DashboardRoute: typeof DashboardRoute
  DepreciationsRoute: typeof DepreciationsRoute
  EstimatesRoute: typeof EstimatesRoute
  ExpensesRoute: typeof ExpensesRoute
  ExportRoute: typeof ExportRoute
  InvoicesRoute: typeof InvoicesRoute
  LoginRoute: typeof LoginRoute
  RemindersRoute: typeof RemindersRoute
  SettingsRoute: typeof SettingsRoute
  SuppliersRoute: typeof SuppliersRoute
  TenantPickerRoute: typeof TenantPickerRoute
  ContractsIdRoute: typeof ContractsIdRoute
  ContractsNewRoute: typeof ContractsNewRoute
  CustomersIdRoute: typeof CustomersIdRoute
  CustomersNewRoute: typeof CustomersNewRoute
  EstimatesIdRoute: typeof EstimatesIdRoute
  EstimatesNewRoute: typeof EstimatesNewRoute
  ExpensesIdRoute: typeof ExpensesIdRoute
  ExpensesDurcharbeiteRoute: typeof ExpensesDurcharbeiteRoute
  ExpensesExportRoute: typeof ExpensesExportRoute
  ExpensesNewRoute: typeof ExpensesNewRoute
  ExpensesUploadRoute: typeof ExpensesUploadRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  SettingsCategoriesRoute: typeof SettingsCategoriesRoute
  SuppliersIdRoute: typeof SuppliersIdRoute
  ContractsIdEditRoute: typeof ContractsIdEditRoute
  EstimatesIdEditRoute: typeof EstimatesIdEditRoute
  ExpensesIdEditRoute: typeof ExpensesIdEditRoute
  ExpensesIdOcrDebugRoute: typeof ExpensesIdOcrDebugRoute
  InvoicesIdEditRoute: typeof InvoicesIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tenant-picker': {
      id: '/tenant-picker'
      path: '/tenant-picker'
      fullPath: '/tenant-picker'
      preLoaderRoute: typeof TenantPickerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders': {
      id: '/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof RemindersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses': {
      id: '/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates': {
      id: '/estimates'
      path: '/estimates'
      fullPath: '/estimates'
      preLoaderRoute: typeof EstimatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/depreciations': {
      id: '/depreciations'
      path: '/depreciations'
      fullPath: '/depreciations'
      preLoaderRoute: typeof DepreciationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts': {
      id: '/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ContractsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cashflow': {
      id: '/cashflow'
      path: '/cashflow'
      fullPath: '/cashflow'
      preLoaderRoute: typeof CashflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers_/$id': {
      id: '/suppliers_/$id'
      path: '/suppliers/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof SuppliersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/categories': {
      id: '/settings_/categories'
      path: '/settings/categories'
      fullPath: '/settings/categories'
      preLoaderRoute: typeof SettingsCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/new': {
      id: '/invoices_/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id': {
      id: '/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/upload': {
      id: '/expenses_/upload'
      path: '/expenses/upload'
      fullPath: '/expenses/upload'
      preLoaderRoute: typeof ExpensesUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/new': {
      id: '/expenses_/new'
      path: '/expenses/new'
      fullPath: '/expenses/new'
      preLoaderRoute: typeof ExpensesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/export': {
      id: '/expenses_/export'
      path: '/expenses/export'
      fullPath: '/expenses/export'
      preLoaderRoute: typeof ExpensesExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/durcharbeite': {
      id: '/expenses_/durcharbeite'
      path: '/expenses/durcharbeite'
      fullPath: '/expenses/durcharbeite'
      preLoaderRoute: typeof ExpensesDurcharbeiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/$id': {
      id: '/expenses_/$id'
      path: '/expenses/$id'
      fullPath: '/expenses/$id'
      preLoaderRoute: typeof ExpensesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates_/new': {
      id: '/estimates_/new'
      path: '/estimates/new'
      fullPath: '/estimates/new'
      preLoaderRoute: typeof EstimatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates_/$id': {
      id: '/estimates_/$id'
      path: '/estimates/$id'
      fullPath: '/estimates/$id'
      preLoaderRoute: typeof EstimatesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers_/new': {
      id: '/customers_/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof CustomersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers_/$id': {
      id: '/customers_/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts_/new': {
      id: '/contracts_/new'
      path: '/contracts/new'
      fullPath: '/contracts/new'
      preLoaderRoute: typeof ContractsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts_/$id': {
      id: '/contracts_/$id'
      path: '/contracts/$id'
      fullPath: '/contracts/$id'
      preLoaderRoute: typeof ContractsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id_/edit': {
      id: '/invoices_/$id_/edit'
      path: '/invoices/$id/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof InvoicesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/$id_/ocr-debug': {
      id: '/expenses_/$id_/ocr-debug'
      path: '/expenses/$id/ocr-debug'
      fullPath: '/expenses/$id/ocr-debug'
      preLoaderRoute: typeof ExpensesIdOcrDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses_/$id_/edit': {
      id: '/expenses_/$id_/edit'
      path: '/expenses/$id/edit'
      fullPath: '/expenses/$id/edit'
      preLoaderRoute: typeof ExpensesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimates_/$id_/edit': {
      id: '/estimates_/$id_/edit'
      path: '/estimates/$id/edit'
      fullPath: '/estimates/$id/edit'
      preLoaderRoute: typeof EstimatesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts_/$id_/edit': {
      id: '/contracts_/$id_/edit'
      path: '/contracts/$id/edit'
      fullPath: '/contracts/$id/edit'
      preLoaderRoute: typeof ContractsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AuditLogRoute: AuditLogRoute,
  CashflowRoute: CashflowRoute,
  ContractsRoute: ContractsRoute,
  CustomersRoute: CustomersRoute,
  DashboardRoute: DashboardRoute,
  DepreciationsRoute: DepreciationsRoute,
  EstimatesRoute: EstimatesRoute,
  ExpensesRoute: ExpensesRoute,
  ExportRoute: ExportRoute,
  InvoicesRoute: InvoicesRoute,
  LoginRoute: LoginRoute,
  RemindersRoute: RemindersRoute,
  SettingsRoute: SettingsRoute,
  SuppliersRoute: SuppliersRoute,
  TenantPickerRoute: TenantPickerRoute,
  ContractsIdRoute: ContractsIdRoute,
  ContractsNewRoute: ContractsNewRoute,
  CustomersIdRoute: CustomersIdRoute,
  CustomersNewRoute: CustomersNewRoute,
  EstimatesIdRoute: EstimatesIdRoute,
  EstimatesNewRoute: EstimatesNewRoute,
  ExpensesIdRoute: ExpensesIdRoute,
  ExpensesDurcharbeiteRoute: ExpensesDurcharbeiteRoute,
  ExpensesExportRoute: ExpensesExportRoute,
  ExpensesNewRoute: ExpensesNewRoute,
  ExpensesUploadRoute: ExpensesUploadRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  SettingsCategoriesRoute: SettingsCategoriesRoute,
  SuppliersIdRoute: SuppliersIdRoute,
  ContractsIdEditRoute: ContractsIdEditRoute,
  EstimatesIdEditRoute: EstimatesIdEditRoute,
  ExpensesIdEditRoute: ExpensesIdEditRoute,
  ExpensesIdOcrDebugRoute: ExpensesIdOcrDebugRoute,
  InvoicesIdEditRoute: InvoicesIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
